import React, { lazy, Suspense, useEffect, useState } from "react";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { DndProvider } from "react-dnd";
import { HTML5Backend } from "react-dnd-html5-backend";
import { Routes, Route, Navigate, useLocation } from "react-router-dom";
import { CircleLoader } from "react-spinners";
import { Colors } from "../theme/colors";
import ProtectedRoutes from "../components/Utils/ProtectedRoutes/ProtectedRoutes";
import InviteUserLinkPage from "../screens/InviteUser/InviteUesrLinkPage";
import ForgotPassword from "../screens/forgotpassword/forgotpassword";
import EditEmployer from "../screens/ClientsList/EditEmployer/EditEmployer";
import CreateEmployer from "../screens/ClientsList/CreateEmployer/CreateEmployer";
import CampaignForm from "../screens/InstantJob/CampaignForm/CampaignForm";
import EditCampaignForm from "../screens/EditInstantJob/CampaignForm/CampaignForm";
import InstantInvite from "../screens/InstantJob/InstantInvite/InstantInvite";
import { getUserByEmailSlice } from "../redux/user/user-slice";
import { useAppDispatch, useAppSelector } from "../redux/hooks";

const LoginScreen = lazy(() => import("../screens/Login/LoginScreen"));
const RegistrationScreen = lazy(() => import("../screens/Registration/RegistrationScreen"));
const DashboardNew = lazy(() => import("../components/dashboard/DashboardNew"));
const JobDashboard = lazy(() => import("../screens/Home/JobDashboard"));
const CandidatesLists = lazy(() => import("../screens/Candidates/CandidatesLists"));
const Templates = lazy(() => import("../screens/Templates/Templates"));
const CustomForm = lazy(() => import("../screens/CustomForm/Customform"));
const CampainListNew = lazy(() => import("../screens/campaign/CampainListNew"));
const CreateCampaignNew = lazy(() => import("../screens/campaign/CreateCampaignNew"));
const CampaignNameAndTitle = lazy(() => import("../screens/campaign/campaignNameAndTitle"));
const GenerateQuestoinAndVideo = lazy(() => import("../screens/campaign/GenerateQuesAndVideo"));
const InstantJob = lazy(() => import("../screens/InstantJob/InstantJob"));
const CompanyList = lazy(() => import("../screens/CompanyInformation/CompanyList"));
const ClientsList = lazy(() => import("../screens/ClientsList/ClientsList"));
const CandidateInfo = lazy(() => import("../screens/Candidates/CandidateInfo"));
const Users = lazy(() => import("../screens/Users/Users"));
const PrivacyPolicy = lazy(() => import("../screens/Privacy/PrivacyPolicy"));
const TermsOfServices = lazy(() => import("../screens/Privacy/TermsOfServices"));
const SelectPackage = lazy(() => import("../screens/Subscription/SelectPackages"));
const BillingMethod = lazy(() => import("../screens/Subscription/BillingMethods"));
const OnboardingMain = lazy(() => import("../screens/Onboarding/OnboardingMain"));

function App() {
  const dispatch = useAppDispatch();
  const { userData } = useAppSelector((state: any) => state.user);

  // const [hasToken, setHasToken] = useState<boolean | null>(null);

  // useEffect(() => {
  //   const token = localStorage.getItem("token");
  //   const userEmail = localStorage.getItem("userName");

  //   setHasToken(!!token);

  //   if (token && userEmail && !userData?.User_Email) {
  //     dispatch(getUserByEmailSlice(userEmail));
  //   }
  // }, [dispatch]);

  const tokenFromStorage = localStorage.getItem("token");
  const [hasToken, setHasToken] = useState<boolean>(!!tokenFromStorage);

  useEffect(() => {
    const userEmail = localStorage.getItem("userName");
    if (hasToken && userEmail && !userData?.User_Email) {
      dispatch(getUserByEmailSlice(userEmail));
    }
  }, [dispatch, hasToken, userData?.User_Email]);

  if (hasToken === null) {
    return (
      <div
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          height: "100vh",
          background: "white",
        }}
      >
        <CircleLoader color="#AA19D5" />
      </div>
    );
  }

  return (
    <div
      className="App"
      style={{
        background: Colors.gray_E5,
        position: "relative",
        height: "100vh",
      }}
    >
      <Suspense
        fallback={
          <div
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              height: "100vh",
              background: "white",
            }}
          >
            <CircleLoader color="#AA19D5" />
          </div>
        }
      >
        <DndProvider backend={HTML5Backend}>
          <Routes>
            <Route
              path="/"
              element={hasToken ? <Navigate to="/dashboard" replace /> : <LoginScreen />}
            />
            <Route
              path="/login"
              element={hasToken ? <Navigate to="/dashboard" replace /> : <LoginScreen />}
            />
            <Route
              path="/registration"
              element={hasToken ? <Navigate to="/dashboard" replace /> : <RegistrationScreen />}
            />
            <Route path="/registration/:code" element={<RegistrationScreen />} />
            <Route path="/forgotpassword" element={<ForgotPassword />} />
            <Route path="/invite/:id/:eId/:statusId" element={<InviteUserLinkPage />} />

            <Route
              path="/"
              element={
                <ProtectedRoutes redirectTo="/login">
                  <DashboardNew />
                </ProtectedRoutes>
              }
            >
              <Route path="dashboard" element={<JobDashboard />} />
              <Route path="campaign" element={<CampainListNew />} />
              <Route path="campaign/create" element={<CreateCampaignNew pageType="create" />} />
              <Route path="campaign/edit" element={<CreateCampaignNew pageType="edit" />} />
              <Route path="campaign/title" element={<CampaignNameAndTitle />} />
              <Route path="campaign/generate" element={<GenerateQuestoinAndVideo />} />
              <Route path="campaign/instant" element={<InstantJob pageType="instant" />} />
              <Route path="campaign/instant/create" element={<CampaignForm pageType="create" />} />
              <Route path="campaign/instant/edit" element={<EditCampaignForm pageType="edit" />} />
              <Route path="campaign/instant/invite" element={<InstantInvite />} />
              <Route path="templates" element={<Templates />} />
              <Route path="custom-form" element={<CustomForm />} />
              <Route path="company" element={<CompanyList />} />
              <Route path="clients" element={<ClientsList />} />
              <Route path="/clients/edit" element={<EditEmployer />} />
              <Route path="/clients/create" element={<CreateEmployer />} />
              <Route path="candidates" element={<CandidatesLists />} />
              <Route path="/candidates/info" element={<CandidateInfo />} />
              <Route path="/user" element={<Users />} />
              <Route path="/privacy-policy" element={<PrivacyPolicy />} />
              <Route path="/terms-of-condition" element={<TermsOfServices />} />
              <Route path="/packages" element={<SelectPackage />} />
              <Route path="/billing-method" element={<BillingMethod />} />
              <Route path="/" element={<Navigate to="/dashboard" replace />} />
            </Route>

            <Route
              path="/onboarding"
              element={
                <ProtectedRoutes redirectTo="/login">
                  <OnboardingMain />
                </ProtectedRoutes>
              }
            />
          </Routes>
        </DndProvider>
      </Suspense>

      <ToastContainer />
    </div>
  );
}

export default App;
